import rect from '../Asset/Skills/reactjs-ar21.svg'
import javascript from '../Asset/Skills/javascript-ar21.svg'
import node from '../Asset/Skills/nodejs-ar21.svg'
import htmls from '../Asset/Skills/w3_html5-ar21.svg'
import mongo from '../Asset/Skills/mongodb-ar21.svg'
import tailwind from '../Asset/Skills/tailwindcss-ar21.svg'
import git from '../Asset/Skills/github-ar21.svg'
import pyhtone from '../Asset/Skills/python-ar21.svg'
import expre from '../Asset/Skills/expressjs-ar21.svg'
import nextjss from '../Asset/Skills/nextjs.png'
import cashcadin from '../Asset/Skills/css3-alt.svg'
import './skill.css'

import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(useGSAP, ScrollTrigger);


const Skills=()=>{
    useGSAP(() => {

        gsap.from("#web", { y: 50, opacity: 0.5 ,duration: 1.5, ease: "ease.in", delay: 1, scrollTrigger:{trigger:"#web",toggleActions:"restart pause  reverse pause"} });
    })
    return<>
    <h1 className=" lg:text-5xl  text-4xl   font-semibold  underline underline-offset-8   p-4  font-serif text-blue-600   mt-12 lg:mt-0 ">
        Skills</h1>

    <div id="skills" className='flex w-full  flex-col  h-full   text-sm items-center justify-center gap-24   '>



        <div className='flex  gap-3 justify-center   flex-col lg:flex-row  items-center  font-serif p-4'>
            <div className=' flex flex-col shadow-lg shadow-opacity-50 shadow-orange-400 bg-sky-200 w-96 border-4 opacity-80 border-s-amber-600 p-2 justify-center items-center h-32' id='web'>
                <h1 className='text-center  text-blue-600  text-2xl'>Web design</h1>
                <p className='text-center text-gray-800'> 
                    I love designs and it's the first step before creating any website as I can give layout to my imagination.</p>

            </div>
            <div className=' flex flex-col shadow-lg shadow-opacity-50 shadow-orange-400 bg-sky-200 w-96 border-4 opacity-80 border-s-amber-600 p-2 justify-center items-center h-32'id='web' >
                <h1 className='text-center  text-blue-600  text-2xl'>Web Development</h1>
                <p className='text-center text-gray-800'> 
                I am a Full Stack Web Developer (MERN) and have quite some experience in it as well..</p>

            </div>
            <div className=' flex flex-col shadow-lg shadow-opacity-50 shadow-orange-400 bg-sky-200 w-96 border-4 opacity-80 border-s-amber-600 p-2 justify-center items-center h-32'id='web'>
                <h1 className='text-center  text-blue-600  text-2xl'>Problem Solving</h1>
                <p className='text-center text-gray-800'> 
                I love solving problems whether programming problems or real life problems..</p>

            </div>
            
    
        </div>

        <div className='flex flex-col  text-gray-600  w-full gap-8'>
            <h1 className='text-3xl font-bold p-2 ml-2 lg:text-3xl italic font-sans-serif text-center'>TECH I'M <b className='underline underline-offset-4 underline-red-600 text-gray-800'>FAMILIAR </b> WITH</h1>


        <div className='flex items-center  mt-2  gap-4 w-full p-4 justify-center justify-items-center' >

            <div className="flex gap-3  justify-center items-center w-full" >
                <div className='flex flex-col gap-4 justify-center items-center  w-1/2'>
                             <div><img src={javascript} alt='javascript'/></div>
                             <div><img src={expre} alt='javascript'/></div>

                             <div><img src={node} alt='javascript'/></div>
                             <div><img src={cashcadin} alt='javascript' className='w-16 h-16'/></div>



                </div>
                <div className='flex flex-col gap-4 w-1/2 items-center'>
                             <div><img src={mongo} alt='javascript'/></div>
                             <div><img src={tailwind} alt='javascript'/></div>

                             <div><img src={pyhtone} alt='javascript'/></div>
                             <div><img src={htmls} alt='javascript'/></div>



                </div>
                <div className='flex flex-col gap-4 w-1/2 items-center'>
                             <div><img src={git} alt='javascript'/></div>
                             <div><img src={rect} alt='javascript'/></div>

                             <div><img src={nextjss} alt='javascript' className='w-24 h-24'/></div>
                    



                </div>
       
              
            </div>
          
          

        </div>
      
        


        </div>
 
   
   
   
     
    

      
        
    </div>




    </>
    

}

export default Skills;